"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Block = _interopRequireDefault(require("./Block"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var BlockField =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(BlockField, _PureComponent);

  function BlockField(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    console.warn('Form.BlockField is not recommend. Use Form.FieldSet instead.');
    return _this;
  }

  var _proto = BlockField.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        other = _objectWithoutPropertiesLoose(_this$props, ["children"]);

    return _react.default.createElement(_Block.default, other, children);
  };

  return BlockField;
}(_react.PureComponent);

BlockField.propTypes = {
  children: _propTypes.default.any,
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.any
};
var _default = BlockField;
exports.default = _default;